import { Routes } from '@angular/router';
import { accessRightsGuard } from './guard/access-rights.guard';
import { Action, RouteData, AccessRight } from './constants/enum';
import { actionTypeGuard } from './guard/action-type.guard';

// Components
import { NavigationComponent } from '@components/navigation';
import { CustomerTableComponent } from '@components/customer';
import { CustomerTabsComponent } from '@components/customer/customer-tabs/customer-tabs.component';
import {
  AccountManagerTableComponent,
  AccountManagerFormComponent,
} from '@components/account-manager';
import { ReleaseNotesTableComponent, ReleaseNotesFormComponent } from '@components/release-notes';
import { IntegrationTabsComponent, IntegrationFormComponent } from '@components/integration';

export const routes: Routes = [
  {
    path: '',
    component: NavigationComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'customers' },
      {
        path: 'customers',
        component: CustomerTableComponent,
        canMatch: [accessRightsGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Customers],
          [RouteData.PropBreadcrumb]: 'Customers',
        },
      },
      {
        path: 'customers/:type',
        component: CustomerTabsComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Customers],
          [RouteData.PropBreadcrumb]: 'Customers/:type',
          [RouteData.PropActionTypes]: [Action.create],
        },
      },
      {
        path: 'customers/:type/:id',
        component: CustomerTabsComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Customers],
          [RouteData.PropBreadcrumb]: 'Customers/:type',
          [RouteData.PropActionTypes]: [Action.edit],
        },
      },
      {
        path: 'integrations',
        redirectTo: 'integrations/operational',
        pathMatch: 'full',
      },
      {
        path: 'integrations/:integrationType',
        component: IntegrationTabsComponent,
        canMatch: [accessRightsGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Integrations],
          [RouteData.PropBreadcrumb]: 'Integrations/:integrationType',
        },
      },
      {
        path: 'integrations/:integrationType/:type',
        component: IntegrationFormComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Integrations],
          [RouteData.PropBreadcrumb]: 'Integrations/:integrationType/:type',
          [RouteData.PropActionTypes]: [Action.create],
        },
      },
      {
        path: 'integrations/:integrationType/:type/:id',
        component: IntegrationFormComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Integrations],
          [RouteData.PropBreadcrumb]: 'Integrations/:integrationType/:type',
          [RouteData.PropActionTypes]: [Action.edit],
        },
      },
      {
        path: 'managers',
        component: AccountManagerTableComponent,
        canMatch: [accessRightsGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Managers],
          [RouteData.PropBreadcrumb]: 'Managers',
        },
      },
      {
        path: 'managers/:type',
        component: AccountManagerFormComponent,
        canMatch: [accessRightsGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.Managers],
          [RouteData.PropBreadcrumb]: 'Managers/:type',
          [RouteData.PropActionTypes]: [Action.create, Action.edit],
        },
      },
      {
        path: 'release-notes',
        canMatch: [accessRightsGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.ProductAdmin],
          [RouteData.PropBreadcrumb]: 'Release Notes',
        },
        component: ReleaseNotesTableComponent,
      },
      {
        path: 'release-notes/:type',
        component: ReleaseNotesFormComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.ProductAdmin],
          [RouteData.PropBreadcrumb]: 'Release Notes/:type',
          [RouteData.PropActionTypes]: [Action.create],
        },
      },
      {
        path: 'release-notes/:type/:id',
        component: ReleaseNotesFormComponent,
        canMatch: [accessRightsGuard],
        canActivate: [actionTypeGuard],
        data: {
          [RouteData.PropAnyRights]: [AccessRight.ProductAdmin],
          [RouteData.PropBreadcrumb]: 'Release Notes/:type',
          [RouteData.PropActionTypes]: [Action.edit, Action.view],
        },
      },
    ],
  },
  { path: '**', redirectTo: '/customers' },
];
